import {jsonMember, jsonObject} from "typedjson";
import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";
import {PitActivity} from "./pit-activity";
import {DxGridToolbarAction} from "../../dx-grid/domain/ui-options/toolbar/dx-grid-toolbar-action";
import {DxGridToolbarActionResolver} from "../../dx-grid/domain/providers/dx-grid-toolbar-action-resolver";


/** Строка грида с мероприятиями. */
@jsonObject
export class PitActivityGridRow extends DxGridRow implements DxGridToolbarActionResolver {
  /** ID мероприятия **/
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _id: number;

  /** Код мероприятия. **/
  @jsonMember({name: "code", constructor: String, emitDefaultValue: false, isRequired: false })
  private _code: string;

  /** Общие реквизиты мероприятия */
  @jsonMember({name: "activity", constructor: PitActivity, emitDefaultValue: false, isRequired: false })
  private _activity: PitActivity = new PitActivity();

  /** Название мероприятия. **/
  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  protected _name: string;

  /** Тип IT-мероприятия. **/
  @jsonMember({name: "type", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _type: number;

  /** Итого по всем периодам **/
  @jsonMember({name: "totalAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _totalAmount: number;

  /** Сумма за первый отчетный период. **/
  @jsonMember({name: "firstPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _firstPeriodAmount: number;

  /** Сумма за второй отчетный период. **/
  @jsonMember({name: "secondPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _secondPeriodAmount: number;

  /** Сумма за третий отчетный период. **/
  @jsonMember({name: "thirdPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false })
  protected _thirdPeriodAmount: number;

  /** Порядок довнесения средств. **/
  @jsonMember({name: "stateProgramId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _stateProgramId: number;

  /** Функциональный заказчик **/
  @jsonMember({name: "funcCustomerId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _funcCustomerId: number;

  /** Государственный заказчик */
  @jsonMember({name: "govCustomerId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _govCustomerId: number;

  /** Блок */
  @jsonMember({name: "blockId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _blockId: number;

  /** Подблок */
  @jsonMember({name: "subBlockId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _subBlockId: number;

  /** Статус */
  @jsonMember({name: "statusId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _statusId: number;

  /** Плановая дата объявления закупки */
  @jsonMember({name: "purchaseStartPlanDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  private _purchaseStartPlanDate: Date;

  /** Дата актуальности */
  @jsonMember({name: "actualDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  private _actualDate: Date;

  /** Дата последнего изменения */
  @jsonMember({name: "changeDate", constructor: Date, emitDefaultValue: false, isRequired: false})
  private _changeDate: Date;

  /** Автор последнего изменения */
  @jsonMember({name: "changeUserFio", constructor: String, emitDefaultValue: false, isRequired: false })
  private _changeUserFio: string;

  /**  */
  @jsonMember({name: "planTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _planTypeId: number;

  /** вкючалка кнопок на тулбаре */
  public canExecuteToolbarAction(action: DxGridToolbarAction): boolean {
    switch (action.type) {
      case 'COPY':
        return this.statusId == 3 || this.statusId === 4;
    }
    return true;
  }

  constructor() {
    super();
    this._isNew = !this._id;
  }

  public getRowId(): number {
    return this._id ? this._id : this._rowId;
  }

  public getRowTitle(): string {
    return 'мероприятие ' + this._code;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get activityCode(): string {
    return this._activity.code;
  }

  set activityCode(value: string) {
    this._activity.code = value;
  }

  get name(): string {
    return this._activity.name;
  }

  set name(value: string) {
    this._activity.name = value;
  }

  get type(): number {
    return this._activity.typeId;
  }

  set type(value: number) {
    this._activity.typeId = value;
  }

  get totalAmount(): number {
    return this._totalAmount;
  }

  set totalAmount(value: number) {
    this._totalAmount = value;
  }

  get firstPeriodAmount(): number {
    return this._firstPeriodAmount;
  }

  set firstPeriodAmount(value: number) {
    this._firstPeriodAmount = value;
  }

  get secondPeriodAmount(): number {
    return this._secondPeriodAmount;
  }

  set secondPeriodAmount(value: number) {
    this._secondPeriodAmount = value;
  }

  get thirdPeriodAmount(): number {
    return this._thirdPeriodAmount;
  }

  set thirdPeriodAmount(value: number) {
    this._thirdPeriodAmount = value;
  }

  get stateProgramId(): number {
    return this._stateProgramId;
  }

  set stateProgramId(value: number) {
    this._stateProgramId = value;
  }

  get funcCustomerId(): number {
    return this._funcCustomerId;
  }

  set funcCustomerId(value: number) {
    this._funcCustomerId = value;
  }

  get govCustomerId(): number {
    return this._govCustomerId;
  }

  set govCustomerId(value: number) {
    this._govCustomerId = value;
  }

  get activityId(): number {
    return this._activity.id;
  }

  get curatorId(): number {
    return this._activity.curatorId;
  }

  get activity(): PitActivity {
    return this._activity;
  }

  set activity(value: PitActivity) {
    this._activity = value;
  }

  get blockId(): number {
    return this._blockId;
  }

  set blockId(value: number) {
    this._blockId = value;
  }

  get subBlockId(): number {
    return this._subBlockId;
  }

  set subBlockId(value: number) {
    this._subBlockId = value;
  }

  get statusId(): number {
    return this._statusId;
  }

  set statusId(value: number) {
    this._statusId = value;
  }

  get purchaseStartPlanDate(): Date {
    return this._purchaseStartPlanDate;
  }

  set purchaseStartPlanDate(value: Date) {
    this._purchaseStartPlanDate = value;
  }

  get actualDate(): Date {
    return this._actualDate;
  }

  set actualDate(value: Date) {
    this._actualDate = value;
  }

  get changeDate(): Date {
    return this._changeDate;
  }

  set changeDate(value: Date) {
    this._changeDate = value;
  }

  get changeUserFio(): string {
    return this._changeUserFio;
  }

  set changeUserFio(value: string) {
    this._changeUserFio = value;
  }

  get planTypeId(): number {
    return this._planTypeId;
  }

  set planTypeId(value: number) {
    this._planTypeId = value;
  }

  get isFinishedStr(): string {
    return (this._activity.isFinished) ? 'Да' : 'Нет';
  }

}
